import { SaleItem } from "../../models/saleItem";

export const RestaurantHelper = {
    getTotalQuantity: (saleItems: SaleItem[]): number | null => {
        var total = saleItems.reduce((total, item) => total + item.available, 0);
        return total;
    }
}